import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["articles", "subcategories", "translatedToLanguages", "translations", "id"];
import { List, Record } from 'immutable';
import Article from './ArticleRecord';
import { oldCategoryEmptyState } from './edit/CategoryRecord';
import { NameTranslationRecord } from './CategoryTranslationRecord';
class CategoryEntity extends Record(Object.assign({}, oldCategoryEmptyState, {
  subcategories: List(),
  articles: List(),
  id: undefined,
  nameTranslations: List()
})) {
  static from(_ref) {
    let {
        articles = [],
        subcategories = [],
        translatedToLanguages = [],
        translations = [],
        id
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return new CategoryEntity(Object.assign({
      // see https://git.hubteam.com/HubSpot/knowledge-content-ui/pull/4301#discussion_r2557972
      id: id ? id.toString() : undefined,
      articles: List(articles).map(article => {
        const articleRecord = new Article(article);
        return articleRecord.values.hs_id ? articleRecord.values.hs_id.toString() : undefined;
      }).filter(articleId => articleId !== undefined),
      subcategories: List(subcategories).map(subcategory => subcategory.id ? subcategory.id.toString() : undefined).filter(articleId => articleId !== undefined),
      translatedToLanguages: List(translatedToLanguages),
      translations: List(translations),
      nameTranslations: List(translations.map(NameTranslationRecord))
    }, rest));
  }
}
export default CategoryEntity;